import {
  FilterData,
  SortData,
} from '@services/requests/routeCalculator/routesCalculationService/interfaces';
import { RouteWidgetResult } from '@services/requests/routeCalculator/routesCalculationService/types';

import { RouteWidgetParams } from './types';

export const FLOAT_NUMBER_REGEXP = /^\d+(,|\.)\d+$/;

//\d+(?=((,|\.)\d+))\1

const DELIVERY_FORM_CONSTANTS = {
  settings: {
    currencyId: '',
    primaryLanguageId: '',
    secondaryLanguageId: '',
  },
  routeParams: {
    cargoType: undefined,
    truckParameters: {
      truckParameters: [
        {
          truckId: null,
          truckQuantity: 1,
          eachTruckWeight: 1500,
          palletsLoaded: [],
          withPallets: false,
        },
      ],
      isCustomConditionsOpen: false,
      isDangerousCargo: false,
      targetCurrencyId: '1',
    },
    containerParameters: {
      containerParameters: [
        {
          containerId: null,
          containerType: '2',
          containerQuantity: 1,
          eachContainerWeight: null,
          palletsLoaded: [],
          withPallets: false,
        },
      ],
      isCustomConditionsOpen: false,
      isDangerousCargo: false,
      targetCurrencyId: '1',
    },
    customCargoParameters: {
      customCargoParameters: [
        {
          parametersType: 'base',
          parametersCargoCalcType: 'volume',
          baseParameters: {
            quantity: 1,
            length: '1',
            width: '1',
            height: '1',
            weight: '10',
          },
          palletParameters: {
            type: '0',
            quantity: 1,
            normativeHeightOfStacking: '1',
            weight: 10000,
          },
          volumeParameters: {
            volume: '1',
            weight: '10',
            height: 1,
          },
        },
      ],
      isCustomConditionsOpen: false,
      isDangerousCargo: false,
      targetCurrencyId: '1',
      cargoFingerprint: '',
      transportTypes: [],
    },
    endLocation: undefined,
    endTransportingCondition: '',
    isDangerCargo: false,
    requiredTransportingTypes: [],
    startExpeditionDate: new Date(),
    startLocation: undefined,
    startTransportingCondition: '',
    isNeedPrekeridge: false,
    isNeedContainerRent: true,
    isWithoutPrekeridge: false,
    isWithoutOnkeridge: false,
    isFromTerminalRadius: false,
    isToTerminalRadius: false,
    isWithCrossDocking: false,
  } as RouteWidgetParams,
  routes: {
    cargo: {},
    routes: [],
    total: 0,
    minPrice: 0,
    minTime: 0,
    isNotCompleteResult: false,
    countExactSearch: 0,
    countFromTerminalRadius: 0,
    countToTerminalRadius: 0,
    countWithPreCarriage: 0,
    countWithoutOnCarriage: 0,
    countWithoutPreCarriage: 0,
    countWithCrossDocking: 0,
  } as RouteWidgetResult,
  filterParameters: {
    containerRentType: ['COC', 'SOC_RENT'],
    terminals: [],
    startTerminals: [],
    endTerminals: [],
    carriers: [],
    contractors: [],
    deliveryTime: { max: 0, min: 0 },
    isSingleShoulderRoutesOnly: false,
    price: { max: 0, min: 0 },
    transportingTypes: [],
    alternativeRoutes: {
      exactSearch: false,
      fromTerminalRadius: false,
      toTerminalRadius: false,
      withoutOnCarriage: false,
      withoutPreCarriage: false,
      withPreCarriage: false,
      withCrossDocking: false,
    },
  } as FilterData,
  sortData: {
    by: 'price',
    direction: 'asc',
  } as SortData,
  limit: 10,
  offset: 0,
};

export const REST_ROUTE_PARAMS_KEYS = [
  'isStartLoadingIncluded',
  'isEndLoadingIncluded',
  'isDangerCargo',
];
export const ONLY_IDS_ROUTE_PARAMS_KEYS = ['endLocation', 'startLocation'];
export const SHARE_SHORT_LINK_KEY = 'share';
export default DELIVERY_FORM_CONSTANTS;
